import { render } from "./Particles.vue?vue&type=template&id=162f1038"
import script from "./Particles.vue?vue&type=script&lang=js"
export * from "./Particles.vue?vue&type=script&lang=js"

import "./Particles.vue?vue&type=style&index=0&id=162f1038&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__